<template>
    <section class="hero bg-orange border-radius t-white p-3 p-md-6">
        <div class="hero-content">
            <div class="active-users mb-12px py-4px px-12px">{{activeUsers}} active users today</div>
            <h1 class="mb-2 t-white">{{heading}}</h1>
            <p class="mb-2 t-white fs-18 font-weight-light">{{content}}</p>
            <a class="btn btn-standard" href="/sign-up">Become a member today</a>
        </div>
    </section>
</template>

<script>
    export default {
        name: "CatUxoHero",
        props: {
            activeUsers: {
                type: String,
                required: false
            },
            heading: {
                type: String,
                required: false
            },
            content: {
                type: String,
                required: false
            }
        },
        mounted() {
        }
    }
</script>

<style lang="scss" scoped>
    .hero {
        &:before {
            @include media-breakpoint-down(md) {
                right: -30%;
            }
        }

        &:after {
            @include media-breakpoint-down(md) {
                right: -18%;
            }
        }

        @media (max-width: 767.98px) {
            text-align: center;
            .active-users {
                margin: 0 auto;
            }
        }

        .home & {
            &:before {
                top: -112%;
                right: -18%;
                transform: rotate(30deg);
            }

            &:after {
                right: -8%;
                width: 480px;
                transform: rotate(64deg);
                bottom: -112%;
            }

            &:before {
                @include media-breakpoint-down(md) {
                    right: -30%;
                }
            }

            &:after {
                @include media-breakpoint-down(md) {
                    right: -18%;
                }
            }
        }
    }

    @include media-breakpoint-down(sm) {
        .hero {
            &:before,
            &:after {
                display: none;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/Hero.vue